<template>
    <div>
        <div class="harders">
            <table></table>
            <h4>发布活动列表</h4>
            <div class="jifeng">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                >
                    <van-cell
                        v-for="item in list"
                        :key="item.id"
                    >
                        <template #default>
                            <div class="list_p">
                                <p>{{ item.activityName }} <van-tag size="medium" style="float:right" type="danger">{{item.activityState == 0?'待审批':item.activityState == 1?'已通过':'已驳回'}}</van-tag></p>
                                <p>活动类型：{{item.activityType}} &nbsp;发布时间：{{item.activityStartTime}}</p>
                            </div>
                        </template>
                    </van-cell>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
import { queryPersonalActivity, queryUserDetails } from "@/api/api";
export default {
    name: "gerentijaio",
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
        };
    },
    methods: {
        SetqueryPersonalActivity() {
            queryPersonalActivity().then((res) => {
                this.list = res.data.rows;
                //this.loading = false;
                this.finished = true;
            });
        },
    },
    created() {
        this.SetqueryPersonalActivity();
    },
};
</script>

<style lang="less" scoped>
.list_p {
    p {
        padding-left: 0 !important;
        padding-top: 0 !important;
        &:first-child {
            font-size: .4rem;
            font-weight: normal;
            color: #3d3d3d !important;
        }
        &:last-child{
            font-size: .3rem;
        }
    }
}
.lists {
    position: relative;
    p {
        &:nth-child(2) {
            font-size: 0.2rem;
        }
        &:last-child {
            position: absolute;
            top: 0.5rem;
            right: 0.2rem;
            color: #aa0018 !important;
        }
    }
}
.xiangqing {
    max-height: 13.5rem;
    overflow: auto;
    p {
        padding: 0 !important;
    }
}
h4 {
    text-align: center;
    color: #fff;
    height: 1.4rem;
    font-size: 0.5rem;
    margin: 0;
    margin-top: 1.2rem;
}
.harders {
    width: 100%;
    height: 6rem;
    background-image: url("./../../assets/img/椭圆 631.png");
    background-repeat: no-repeat;
    background-position: 50% -1rem;
    background-size: 150% 6rem;
    .jifeng {
        padding-bottom: 2rem;
        z-index: 0;
        min-height: 16rem;
        width: 90%;
        margin: 0 auto;
        position: relative;
        bottom: -0.5rem;
        border-radius: 0.15rem;
        background: #fff;
        box-shadow: 0px 0 10px 0px rgb(133, 133, 133);
        p,
        h3 {
            padding-left: 1rem;
            padding-top: 0.3rem;
            font-weight: normal;
            color: #999999;
        }
        h3 {
            padding-top: 0.1rem;
            margin: 0;
            color: #333333;
            font-weight: bold;
            font-size: 0.7rem;
            padding-right: 0.8rem;
            .roder {
                border-radius: 1rem;
                border: 1px solid #aa0018;
                color: #aa0018;
                width: 2rem;
            }
        }
    }
}
.bodyss {
    width: 90%;
    margin: 0 auto;
    margin-top: 1rem;
    height: 13rem;
    background: #f9f9f9;
}
.van-cell--clickable {
    height: 1.5rem;
    background: #f9f9f9;
    color: #000000;
}
</style>